import React from 'react';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { CHILDCARE_STOCK_THRESHOLD } from 'Utils/childcare/childcare.consts';

export const getMinRemainingStock = ({ childcare }) => {
  if (!childcare.pricingInfo?.schedules) {
    return 0;
  }
  const remainingStockSchedules = childcare.pricingInfo?.schedules?.map(({ slots }) => {
    const stockSlots =
      slots?.map(({ remainingStock }) => remainingStock)?.filter((rs) => rs > 0) || [];

    const minStockSlots = stockSlots.length > 0 ? Math.min(...stockSlots) : 0;

    return minStockSlots;
  });

  const minRemainingStock = Math.min(...remainingStockSchedules);
  return minRemainingStock;
};

export const UrgentisationChildcareBlock = ({
  childcare,
  type,
  isByDayChildcare = false,
  isFullStayHalfDayChildcare = false,
}) => {
  // here we show the min remaining stock of all schedules slots of the childcare

  const minRemainingStock = getMinRemainingStock({ childcare });

  if (type === 'add' && !!minRemainingStock) {
    if (isByDayChildcare || isFullStayHalfDayChildcare) {
      return (
        <p
          className="my-10 flex items-center justify-center gap-5 text-orange"
          data-testid="urgentisationBlock"
        >
          <span data-testid="urgentisationBlock-label">
            {t('booking.services.childcare.urgentisation')}
          </span>
        </p>
      );
    }
    return (
      <p
        className="my-10 flex items-center justify-center gap-5 text-orange"
        data-testid="urgentisationBlock"
      >
        {minRemainingStock <= CHILDCARE_STOCK_THRESHOLD && (
          <Icon data-testid="ServiceBlock-icon-urgentisation" name={ICONS.WARNING} width="1.5em" />
        )}
        <span data-testid="urgentisationBlock-label">
          {minRemainingStock <= CHILDCARE_STOCK_THRESHOLD
            ? t('booking.services.childcare.childcareAvailabilities', {
                count: minRemainingStock,
              })
            : t('booking.services.childcare.urgentisation')}
        </span>
      </p>
    );
  }
  return null;
};
